import { useContext, useCallback } from 'react'

import { Box } from '@material-ui/core'
import { faMapMarkerAlt, faVideo } from '@fortawesome/pro-solid-svg-icons'
import { faMapMarkerAlt as farMapMarkerAlt, faVideo as farVideo } from '@fortawesome/pro-regular-svg-icons'

import { SelectableIconChips } from '@scoir/college-search'

import ContentModalContext from '../../ContentModalProvider/Context'
import { FIELD_NAMES, LABELS } from '../../components/constants'

const field = FIELD_NAMES.IS_VIRTUAL

const Virtual = () => {
  const { item, onUpdateField, onUpdateFields } = useContext(ContentModalContext)

  const value = item[field]

  const onSelect = useCallback(
    (value: boolean) => {
      if (value) {
        // if virtual, location should be null
        onUpdateFields({
          [field]: value,
          [FIELD_NAMES.LOCATION]: '',
          [FIELD_NAMES.ROOM_BOARD]: false,
        })
      } else {
        onUpdateField(field, value)
      }
    },
    [onUpdateFields, onUpdateField],
  )

  return (
    <Box
      display="flex"
      gridGap={2}
    >
      <SelectableIconChips
        gridItemProps={{ xs: 6 }}
        onSelect={onSelect}
        options={[
          {
            title: LABELS.IN_PERSON,
            faIcon: !value ? faMapMarkerAlt : farMapMarkerAlt,
            value: false,
            selected: !value,
          },
          {
            title: LABELS.VIRTUAL,
            faIcon: value ? faVideo : farVideo,
            value: true,
            selected: value,
          },
        ]}
      />
    </Box>
  )
}

export default Virtual
